// src/shared/api/uiBus.js
export const uiBus = {
  _handlers: Object.create(null),

  on(event, fn) {
    if (!event || typeof fn !== 'function') return () => {};
    const list = (this._handlers[event] = this._handlers[event] || []);
    list.push(fn);

    // unsubscribe
    return () => this.off(event, fn);
  },

  once(event, fn) {
    if (!event || typeof fn !== 'function') return () => {};

    const wrap = (payload) => {
      try {
        fn(payload);
      } finally {
        this.off(event, wrap);
      }
    };

    return this.on(event, wrap);
  },

  off(event, fn) {
    const list = this._handlers[event];
    if (!list || !list.length) return;

    this._handlers[event] = list.filter((x) => x !== fn);

    // temizle
    if (this._handlers[event].length === 0) {
      delete this._handlers[event];
    }
  },

  emit(event, payload) {
    const list = this._handlers[event];
    if (!list || !list.length) return;

    // emit sırasında list değişirse sorun olmasın diye kopya al
    const snapshot = list.slice();
    snapshot.forEach((fn) => {
      try {
        fn(payload);
      } catch (e) {
        // bus yüzünden app kırılmasın
        // istersen burada console.error bırak
        // console.error(`[uiBus] handler error for "${event}"`, e);
      }
    });
  },

  clear(event) {
    if (event) delete this._handlers[event];
    else this._handlers = Object.create(null);
  },
};
